<template>
  <generic-modal
    size=""
    :title="$t('course record configuration')"
    icon="certificate"
    image="/images/icons/course_scoring.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="ui three item top attached tabular menu" ref="tabs">
          <a class="active item" data-tab="general"
            ><i class="info icon"></i> {{ $t("general") }}</a
          >
          <a class="item" data-tab="template"
            ><i class="edit icon"></i> {{ $t("template") }}</a
          >
          <a class="item" data-tab="days">
            <i class="calendar icon"></i> {{ $t("days") }}</a
          >
        </div>
        <div class="ui bottom attached active tab segment" data-tab="general">
          <div class="fields">
            <div class="three wide field">
              <label for="">{{ $t("threshold score") }}</label>
              <input
                type="text"
                name="threshold_score"
                v-model="threshold_score"
              />
            </div>
            <div class="ten wide field">
              <label for="">{{
                $t(
                  "recovery 1 and recovery 2 records show only students below threshold",
                )
              }}</label>
              <div class="ui toggle checkbox">
                <input
                  type="checkbox"
                  name="example"
                  v-model="recovery_threshold"
                />
                <label>{{ $t("recovery records threshold") }}</label>
              </div>
            </div>
          </div>

          <div class="ui message">
            <!-- <div class="header"> -->
            <i class="icon info"></i>
            {{
              $t(
                "threshold score is the lowest score used to know if the course is approved or not",
              )
            }}
          </div>
          <!-- </div> -->
        </div>
        <div class="ui bottom attached tab segment" data-tab="template">
          <div class="field">
            <label for="">{{ $t("template") }}</label>
            <wysywyg v-model="template" />
          </div>
        </div>
        <div class="ui bottom attached  tab segment" data-tab="days">
          <days ref="days" />
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import Wysywyg from "@/components/Wysywyg/Wysywyg";
import Days from "./Days";

export default {
  name: "CourseRecordConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    Wysywyg,
    Days,
  },
  computed: {},
  data() {
    return {
      template: {
        css: "",
        js: "",
        html: "",
      },
      threshold_score: 0,
      recovery_threshold: false,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let days = vm.$refs.days.getList();
        local_api(vm, "post", "/course/record/do-save-configuration", {
          s: {
            template: vm.template,
            days: days,
            threshold_score: vm.threshold_score,
            recovery_threshold: vm.recovery_threshold,
          },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/course/record/do-get-configuration")
      .then((r) => {
        if (r) {
          vm.template = r.template;
          if (r.days) {
            vm.$refs.days.setList(r.days);
          }
          if (r.threshold_score) {
            vm.threshold_score = r.threshold_score;
          }
          if (r.recovery_threshold) {
            vm.recovery_threshold = r.recovery_threshold;
          }
          /**
           * Set stored configuration
           */
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
  updated: function() {
    let vm = this;
    this.$nextTick(function() {
      window.jQuery(this.$refs.type).dropdown({
        onChange(value) {
          let index = window.jQuery(this).data("index");
          vm.attributes[index].type = value;
        },
      });
    });
  },
};
</script>
